import { KeyValue } from '@angular/common';
import { CommentStatus } from './comment-status.enum';

export const commentStatusOptions: KeyValue<string, CommentStatus>[] = [
  {
    key: 'SHARED.TODO',
    value: CommentStatus.Todo
  },
  {
    key: 'SHARED.COMPLETED',
    value: CommentStatus.Completed
  },
  {
    key: 'Under Construction',
    value: CommentStatus.UnderConstruction
  },
  {
    key: 'Groom',
    value: CommentStatus.Groom
  },
  {
    key: 'In Progress',
    value: CommentStatus.InProgress
  },
  {
    key: 'Pending Review',
    value: CommentStatus.PendingReview
  },
  {
    key: 'Closed',
    value: CommentStatus.Closed
  }
];
